import { paymentMethodsCollection } from 'pb-billing-ui/payment-methods.ts';
import { usePbApi } from '~/composables/api';

export type { PaymentMethod } from 'pb-billing-ui/payment-methods.ts';

/**
 * A payer's saved payment methods (`pb-billing-ui`), read and changed through hive's request
 * client. `scope` is `people` for a member's own cards, `companies` for a business's.
 */
export function usePaymentMethods(ownerId: () => number | undefined, scope: 'people' | 'companies' = 'people') {
    return paymentMethodsCollection((url, change) => usePbApi(url, change), ownerId, scope);
}
